/* CASA COTON — « Composer un coffret cadeau » (sections/casa-composer.liquid)
   Moteur vanilla, chargé uniquement sur la page. Données : <script data-ccx-data> rendu en Liquid.
   Parcours : 1) un univers (Maille, Safari, Petit Cœur, Léopard) 2) les articles de cet univers.
   Une pression sur la photo ouvre la fiche (photos à balayer, couleur, taille) ; une pression sur le nom
   ajoute l'article (ou ouvre la fiche s'il faut choisir) et une seconde le retire.
   Panier : mêmes propriétés que les coffrets préparés (Coffret, _bundle_id = compose, _bundle_name,
   _bundle_instance), lignes de frais de broderie (_cc_for, _brd_fee) et cadeau « attache tétine » à 0 €. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ccx]');
  if (!root || root.__ccx) return;
  root.__ccx = true;

  var DATA;
  try { DATA = JSON.parse(root.querySelector('[data-ccx-data]').textContent); } catch (e) { return; }
  var S = DATA.strings || {};
  var T = DATA.thresholds || { ship: 5900, emb: 7900, gift: 9900 };
  var FEE = DATA.fee || {};
  var GIFT = DATA.gift || {};
  if (GIFT.title) GIFT.title = String(GIFT.title).split(' (')[0];
  var MIN = parseInt(DATA.min_items, 10) || 2;
  var LS_KEY = 'ccx:v3';
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ICO_CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12 5 5L20 7"/></svg>';
  var ICO_EMB = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="6" y="4" width="12" height="16" rx="2.5"/><path d="M6 8.5h12M6 12h12M6 15.5h12"/><path d="M18 12c2.2 0 3.5 1.3 3.5 3.5"/></svg>';
  var ICO_GIFT = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="9" r="5.5"/><path d="M8.5 14.5 7 20h10l-1.5-5.5"/><path d="M9.5 9h5"/></svg>';

  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function tpl(str, vars) { return String(str || '').replace(/\{(\w+)\}/g, function (m, k) { return vars && vars[k] != null ? vars[k] : ''; }); }
  function money(c) { var v = (Math.round(c) / 100).toFixed(2).replace('.', ','); return v.replace(/,00$/, '') + ' €'; }
  function money2(c) { return (Math.round(c) / 100).toFixed(2).replace('.', ',') + ' €'; }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[’']/g, '\'').replace(/\s+/g, ' ').trim(); }
  function slug(s) { return norm(s).replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }

  /* ---------------------------------------------------------------- données */
  var P = (DATA.products || []).filter(function (p) { return p && p.variants && p.variants.length; });
  var byId = {};
  P.forEach(function (p) {
    byId[p.id] = p;
    p.colors = p.color_index >= 0 ? (p.options[p.color_index] ? p.options[p.color_index].values : []) : [];
    p.sizes = p.size_index >= 0 ? (p.options[p.size_index] ? p.options[p.size_index].values : []) : [];
  });
  var UNIS = (DATA.universes || []).filter(function (u) { return u && u.handle; });
  var DEFAULT_UNI = (UNIS.filter(function (u) { return u['default']; })[0] || UNIS[0] || {}).handle || '';
  function uniOf(handle) { return UNIS.filter(function (u) { return u.handle === handle; })[0]; }
  function uniProducts(handle) { return P.filter(function (p) { return !handle || p.collections.indexOf(handle) > -1; }); }
  // « Doudou - Safari » s'affiche « Doudou » (le titre réel reste celui du panier)
  function shortTitle(p) { var t = String(p.title); UNIS.forEach(function (u) { var lab = norm(u.label); var tn = norm(t); var sep = [' - ', ' – ']; for (var i = 0; i < sep.length; i++) { var idx = tn.lastIndexOf(sep[i] + lab); if (idx > 0 && idx + sep[i].length + lab.length === tn.length) { t = t.slice(0, idx); break; } } }); return t; }

  /* ---------------------------------------------------------------- état */
  var state = { universe: '', uniColor: {}, items: [], sel: {}, name: '', thread: '', emb: {}, freeKey: '', noGift: false };
  var prevFlags = { ship: false, emb: false, gift: false };
  var started = false;
  try {
    var saved = JSON.parse(localStorage.getItem(LS_KEY) || 'null');
    if (saved && typeof saved === 'object') {
      state.name = saved.name || '';
      state.thread = saved.thread || '';
      state.sel = saved.sel || {};
      state.uniColor = saved.uniColor || {};
      state.emb = saved.emb || {};
      state.freeKey = saved.freeKey || '';
      state.noGift = !!saved.noGift;
      if (saved.universe && uniOf(saved.universe) && (saved.items || []).length) state.universe = saved.universe;
      (saved.items || []).forEach(function (it) { var p = byId[it.pid]; if (!p) return; var v = variantById(p, it.vid); if (v && v.available) state.items.push({ key: String(v.id), pid: p.id, vid: v.id }); });
    }
  } catch (e) {}
  // ?univers=<handle> depuis la home
  try { var qu = new URLSearchParams(location.search).get('univers'); if (qu && uniOf(qu)) state.universe = qu; } catch (e) {}
  function persist() { try { localStorage.setItem(LS_KEY, JSON.stringify({ universe: state.universe, uniColor: state.uniColor, name: state.name, thread: state.thread, sel: state.sel, emb: state.emb, freeKey: state.freeKey, noGift: state.noGift, items: state.items })); } catch (e) {} }

  /* ---------------------------------------------------------------- variantes et couleurs */
  function variantById(p, id) { for (var i = 0; i < p.variants.length; i++) if (p.variants[i].id === id) return p.variants[i]; return null; }
  function selOf(p) { return state.sel[p.id] || (state.sel[p.id] = { color: '', size: '' }); }
  function colorAvailable(p, c) { return p.variants.some(function (v) { return v.available && v.options[p.color_index] === c; }); }
  // Couleur de l'univers : celle choisie par le client, sinon la couleur disponible la plus partagée par ses articles
  function commonColor(handle) {
    if (state.uniColor[handle]) return state.uniColor[handle];
    var count = {};
    uniProducts(handle).forEach(function (p) { p.colors.forEach(function (c) { if (colorAvailable(p, c)) count[norm(c)] = (count[norm(c)] || 0) + 1; }); });
    var best = '', n = 0; Object.keys(count).forEach(function (k) { if (count[k] > n) { n = count[k]; best = k; } });
    return best;
  }
  function defaultColor(p, s) {
    s = s || selOf(p);
    if (s.color && p.colors.indexOf(s.color) > -1) return s.color;
    // couleurs variées : chaque article de l'univers prend une couleur différente (rotation)
    var av = p.colors.filter(function (c) { return colorAvailable(p, c); });
    if (!av.length) return p.colors[0] || '';
    var idx = Math.max(0, uniProducts(state.universe).indexOf(p));
    // Safari : 2 articles sur 3 en rose, le troisième dans une autre couleur
    if (state.universe === 'safari') {
      var rose = av.filter(function (c) { return /rose|pink/i.test(norm(c)); })[0];
      var others = av.filter(function (c) { return c !== rose; });
      if (rose && (idx % 3 !== 2 || !others.length)) return rose;
      if (others.length) return others[Math.floor(idx / 3) % others.length];
    }
    return av[idx % av.length];
  }
  function sizesFor(p, color) {
    return p.sizes.map(function (sz) { var ok = p.variants.some(function (v) { return v.available && v.options[p.size_index] === sz && (p.color_index < 0 || !color || v.options[p.color_index] === color); }); return { label: sz, available: ok }; });
  }
  function findVariant(p, color, size) {
    if (p.has_only_default_variant) return p.variants[0];
    for (var i = 0; i < p.variants.length; i++) {
      var v = p.variants[i];
      if (p.color_index >= 0 && v.options[p.color_index] !== color) continue;
      if (p.size_index >= 0 && v.options[p.size_index] !== size) continue;
      return v;
    }
    return null;
  }
  function resolve(p, s) {
    s = s || selOf(p);
    if (p.has_only_default_variant) return { variant: p.variants[0], color: '', size: '' };
    var color = p.color_index >= 0 ? defaultColor(p, s) : '';
    var size = '';
    if (p.size_index >= 0 && s.size && sizesFor(p, color).some(function (x) { return x.label === s.size; })) size = s.size;
    var variant = (p.size_index >= 0 && !size) ? null : findVariant(p, color, size);
    return { variant: variant, color: color, size: size };
  }
  function needsChoice(p) { var s = selOf(p); if (p.has_only_default_variant) return false; if (p.size_index >= 0 && !s.size) return true; return false; }
  function mediaFor(p, color) {
    var c = slug(color);
    var list = c ? p.media.filter(function (m) { return !m.color || m.color === c; }) : p.media.slice();
    if (c && !list.some(function (m) { return m.color === c; })) {
      var v = p.variants.filter(function (x) { return x.options[p.color_index] === color && x.media_id; })[0];
      if (v) { var vm = p.media.filter(function (m) { return m.id === v.media_id; })[0]; if (vm) list = [vm].concat(list.filter(function (m) { return m.id !== vm.id; })); }
    } else if (c) {
      list.sort(function (a, b) { return (b.color === c ? 1 : 0) - (a.color === c ? 1 : 0); });
    }
    if (!list.length) list = p.media.length ? p.media.slice() : [{ src: p.featured, thumb: p.featured }];
    return list;
  }
  function imageFor(p, color) { return mediaFor(p, color)[0]; }
  function itemOfProduct(p) { return state.items.filter(function (it) { return it.pid === p.id; })[0]; }
  function itemFor(vid) { return state.items.filter(function (it) { return it.vid === vid; })[0]; }

  /* ---------------------------------------------------------------- calculs */
  function subtotal() { return state.items.reduce(function (s, it) { var p = byId[it.pid]; var v = p && variantById(p, it.vid); return s + (v ? v.price : 0); }, 0); }
  function eligibleItems() { return state.items.filter(function (it) { var p = byId[it.pid]; return p && p.embroidery && p.embroidery.eligible; }); }
  function embItems() { return eligibleItems().filter(function (it) { return state.emb[it.key]; }); }
  function flags() { var st = subtotal(); if (PROMO.on) st = state.items.reduce(function (s, it) { var p = byId[it.pid]; var v = p && variantById(p, it.vid); return s + (v ? promoPrice(v.price) : 0); }, 0); return { ship: st >= T.ship, emb: st >= T.emb, gift: st >= T.gift && !!GIFT.variant_id }; }
  function freeItem() {
    var f = flags(); if (!f.emb || !FEE.free_id) return null;
    var list = embItems(); if (!list.length) return null;
    var chosen = list.filter(function (it) { return it.key === state.freeKey; })[0];
    return chosen || list[0];
  }
  function threadsFor() {
    var lists = eligibleItems().map(function (it) { return (byId[it.pid].embroidery.threads || []); }).filter(function (l) { return l.length; });
    if (!lists.length) return [];
    var inter = lists[0].filter(function (t) { return lists.every(function (l) { return l.some(function (x) { return norm(x.name) === norm(t.name); }); }); });
    if (inter.length) return inter;
    var union = []; lists.forEach(function (l) { l.forEach(function (t) { if (!union.some(function (x) { return norm(x.name) === norm(t.name); })) union.push(t); }); });
    return union;
  }
  var PROMO_EL = document.querySelector('[data-ccx-promo]');
  var PROMO = { code: PROMO_EL ? PROMO_EL.getAttribute('data-ccx-promo') : '', pct: PROMO_EL ? (parseFloat(PROMO_EL.getAttribute('data-pct')) || 30) : 0, on: false };
  if (PROMO.code) PROMO.on = true;
  function promoPrice(c) { return c - Math.floor(c * PROMO.pct / 100); } /* 10/10/2026 : même arrondi que la réduction Shopify (remise arrondie au centime inférieur) */
  function pricing() {
    var items = subtotal();
    var embs = embItems();
    var free = freeItem();
    var embN = embs.length;
    var embPaid = Math.max(0, embN - (free ? 1 : 0)) * (FEE.price || 0);
    var f = flags();
    var giftOn = f.gift && !state.noGift && state.name.trim().length > 0;
    var disc = 0;
    if (PROMO.on) state.items.forEach(function (it) { var p = byId[it.pid]; var v = p && variantById(p, it.vid); if (v) disc += v.price - promoPrice(v.price); });
    var total = items + embPaid - disc;
    var saved = (free ? (FEE.price || 0) : 0) + (giftOn ? (GIFT.value || 0) : 0) + disc;
    /* 10/10/2026 (demande de Precilia) : net = sous-total apres remise, c'est lui qui pilote les paliers */
    return { disc: disc, net: items - disc, before: items + embPaid, items: items, embN: embN, embPaid: embPaid, free: free, gift: giftOn, giftPossible: f.gift && !state.noGift, ship: f.ship, total: total, saved: saved, flags: f };
  }

  /* ---------------------------------------------------------------- éléments */
  var els = {
    unis: $('[data-ccx-unis]'), step2: $('[data-ccx-step2]'), results: $('[data-ccx-results]'),
    grid: $('[data-ccx-grid]'), nores: $('[data-ccx-noresults]'), count: $('[data-ccx-count]'),
    items: $('[data-ccx-items]'), embcta: $('[data-ccx-embcta]'), embsheet: $('[data-ccx-embsheet]'), embErr: $('[data-ccx-emb-err]'), name: $('[data-ccx-name]'), threads: $('[data-ccx-threads]'), embitems: $('[data-ccx-embitems]'), embfree: $('[data-ccx-embfree]'), embfee: $('[data-ccx-embfee]'),
    sum: $('[data-ccx-sum]'), err: $('[data-ccx-err]'), add: $('[data-ccx-add]'), addPrice: $('[data-ccx-add-price]'), hint: $('[data-ccx-hint]'),
    side: $('[data-ccx-side]'), bar: $('[data-ccx-bar]'), barTotal: $('[data-ccx-bar-total]'), barCount: $('[data-ccx-bar-count]'), overlay: $('[data-ccx-overlay]'), toast: $('[data-ccx-toast]'),
    pick: $('[data-ccx-pick]'), pickGal: $('[data-ccx-pick-gal]'), pickDots: $('[data-ccx-pick-dots]'), pickTitle: $('[data-ccx-pick-title]'), pickPrice: $('[data-ccx-pick-price]'), pickBody: $('[data-ccx-pick-body]'), pickOk: $('[data-ccx-pick-ok]'), pickRm: $('[data-ccx-pick-rm]')
  };

  /* ---------------------------------------------------------------- univers */
  function renderUnis() {
    if (!els.unis) return;
    els.unis.innerHTML = UNIS.map(function (x) {
      var on = state.universe === x.handle;
      var bg = x.motif || x.image;
      var style = (bg ? '--bg:url(&quot;' + esc(bg) + '&quot;);' : '') + (x.scale ? '--scale:' + esc(x.scale) + ';' : '');
      return '<button type="button" class="ccx-uni' + (x.motif ? ' ccx-uni--motif' : '') + (x.image && !x.motif ? ' ccx-uni--photo' : '') + '" role="radio" aria-checked="' + on + '" data-ccx-universe="' + esc(x.handle) + '"' + (style ? ' style="' + style + '"' : '') + '><span class="ccx-uni__check" aria-hidden="true">' + ICO_CHECK + '</span><span class="ccx-uni__lbl"><b>' + esc(x.label) + '</b>' + (x.text ? '<small>' + esc(x.text) + '</small>' : '') + '</span></button>';
    }).join('');
    var u = uniOf(state.universe);
    if (els.step2) els.step2.textContent = (S.step2 || 'Composez son coffret') + (u ? ' ' + u.label : '');
    root.classList.toggle('ccx--no-uni', !u);
    els.unis.classList.toggle('has-sel', !!u);
  }

  /* ---------------------------------------------------------------- grille */
  function optionLabel(p) {
    var s = selOf(p);
    if (p.has_only_default_variant) return '';
    var parts = [];
    if (p.colors.length > 1) parts.push(resolve(p).color || '');
    if (p.size_index >= 0) parts.push(s.size || '');
    return parts.filter(Boolean).join(' · ');
  }
  /* 10/10/2026 (demande de Precilia) : note et avis sous le titre de chaque article */
  function ratingHtml(p) {
    var n = parseInt(p.rating_count, 10) || 0;
    var r = parseFloat(p.rating) || 0;
    if (!n || !r) return '';
    var pct = Math.max(0, Math.min(100, r * 20));
    return '<span class="ccx-card__rating"><span class="ccx-card__stars" aria-hidden="true"><i style="width:' + pct + '%"></i></span>'
      + '<span class="ccx-card__rtxt">' + String(r).replace('.', ',') + ' (' + n + ')</span></span>';
  }
  function cardHtml(p) {
    var r = resolve(p);
    var it = itemOfProduct(p);
    var color = it ? variantById(p, it.vid).options[p.color_index] : r.color;
    var img = imageFor(p, color);
    var price = r.variant ? money2(r.variant.price) : (p.price_min === p.price_max ? money2(p.price_min) : 'dès ' + money2(p.price_min));
    var h = '<article class="ccx-card' + (it ? ' is-in' : '') + '" data-ccx-card="' + p.id + '" aria-label="' + esc(shortTitle(p)) + (it ? ' · ' + esc(S.added) : '') + '">';
    h += '<button type="button" class="ccx-card__media" data-ccx-media aria-label="' + esc(S.see || 'Voir') + ' ' + esc(shortTitle(p)) + '"><img src="' + esc(img.thumb || img.src || p.featured) + '" alt="" loading="lazy" width="200" height="200">';
    h += '<span class="ccx-card__check" aria-hidden="true">' + ICO_CHECK + '</span>';
    if (p.embroidery && p.embroidery.eligible) h += '<span class="ccx-card__badge" title="' + esc(S.brodable) + '">' + ICO_EMB + '</span>';
    if (p.media.length > 1) h += '<span class="ccx-card__more" aria-hidden="true">' + p.media.length + '</span>';
    h += '</button><button type="button" class="ccx-card__body" data-ccx-toggle aria-pressed="' + (!!it) + '"><span class="ccx-card__title">' + esc(shortTitle(p)) + '</span>' + ratingHtml(p) + (PROMO.on ? '<span class="ccx-card__price">' + (r.variant || p.price_min === p.price_max ? '' : 'dès ') + money2(promoPrice(r.variant ? r.variant.price : p.price_min)) + ' <small class="ccx-card__pct">-' + PROMO.pct + '\u00a0%</small></span><span class="ccx-card__promo"><s>' + price.replace('dès ', '') + '</s></span>' : '<span class="ccx-card__price">' + price + '</span>');
    if (it) { var ol = optionLabel(p); if (ol) h += '<span class="ccx-card__sel">' + esc(ol) + '</span>'; }
    h += '</button></article>';
    return h;
  }
  /* catégorie : vêtements ou accessoires (d'après le nom de l'article) */
  /* 10/10/2026 (demande de Precilia) : l'onglet « Tout » est selectionne par defaut */
  var CAT = '';
  var RX_VET = /combinaison|pyjama|gigoteuse|ensemble|body|bodies|salopette|pull|manteau|brassiere|cardigan|gilet|robe|barboteuse|grenouillere|coffret de naissance|legging|pantalon|veste|short/;
  function catOf(p) { return RX_VET.test(norm(p.title)) ? 'vetements' : 'accessoires'; }
  function setCat(c) {
    CAT = c || '';
    var seg = $('[data-ccx-seg]'); if (!seg) return;
    var btns = seg.querySelectorAll('[data-ccx-cat]'), idx = 0;
    btns.forEach(function (b, i) { var on = b.getAttribute('data-ccx-cat') === CAT; b.setAttribute('aria-checked', on ? 'true' : 'false'); if (on) idx = i; });
    seg.style.setProperty('--i', idx);
    renderGrid();
  }
  function renderGrid() {
    var all = uniProducts(state.universe), seg = $('[data-ccx-seg]');
    if (seg) { seg.querySelectorAll('[data-ccx-cat]').forEach(function (b) { var c = b.getAttribute('data-ccx-cat'); var n = c ? all.filter(function (p) { return catOf(p) === c; }).length : all.length; b.disabled = n === 0; }); if (CAT && !all.some(function (p) { return catOf(p) === CAT; })) { CAT = ''; seg.style.setProperty('--i', 0); seg.querySelectorAll('[data-ccx-cat]').forEach(function (b, i) { b.setAttribute('aria-checked', i === 0 ? 'true' : 'false'); }); } }
    var list = all.filter(function (p) { return !CAT || catOf(p) === CAT; });
    els.grid.innerHTML = list.map(cardHtml).join('');
    els.results.textContent = list.length === 1 ? (S.results_one || '1 article') : tpl(S.results_many || '{n} articles', { n: list.length });
    els.nores.hidden = list.length > 0;
    els.nores.textContent = S.no_results || '';
  }
  function refreshCard(pid) {
    var old = $('[data-ccx-card="' + pid + '"]'); if (!old) return;
    var p = byId[pid]; if (!p) return;
    var tmp = document.createElement('div'); tmp.innerHTML = cardHtml(p);
    old.replaceWith(tmp.firstElementChild);
  }

  /* ---------------------------------------------------------------- fiche article (photos, couleur, taille) */
  var pick = { pid: null, sel: null, last: null, idx: 0 };
  function openPick(pid) {
    var p = byId[pid]; if (!p || !els.pick) return;
    var s = selOf(p);
    var it = itemOfProduct(p);
    pick.pid = pid; pick.idx = 0;
    pick.sel = { color: p.color_index >= 0 ? (it ? variantById(p, it.vid).options[p.color_index] : defaultColor(p, s)) : '', size: it && p.size_index >= 0 ? variantById(p, it.vid).options[p.size_index] : (s.size || '') };
    pick.emb = it ? !!state.emb[it.key] : false;
    pick.last = document.activeElement;
    els.pickTitle.textContent = shortTitle(p);
    /* 10/10/2026 (demande de Precilia) : note et avis sous le titre de la fenetre */
    var pickRating = root.querySelector('[data-ccx-pick-rating]');
    if (pickRating) pickRating.innerHTML = ratingHtml(p);
    renderPick(true);
    els.pick.hidden = false;
    setTimeout(function () { var f = $('[aria-checked="true"]', els.pickBody) || els.pickOk; if (f) try { f.focus({ preventScroll: true }); } catch (e) {} }, 60);
  }
  function renderPick(resetGal) {
    var p = byId[pick.pid]; if (!p) return;
    var r = resolve(p, pick.sel);
    var it = itemOfProduct(p);
    if (resetGal) {
      var list = mediaFor(p, pick.sel.color);
      els.pickGal.innerHTML = list.map(function (m, i) { return '<figure class="ccx-pick__slide"><img src="' + esc(m.src || m.thumb || p.featured) + '" alt="' + esc(shortTitle(p)) + (list.length > 1 ? ' ' + (i + 1) : '') + '" loading="' + (i ? 'lazy' : 'eager') + '" width="600" height="600"></figure>'; }).join('');
      els.pickDots.innerHTML = list.length > 1 ? list.map(function (m, i) { return '<button type="button" class="ccx-pick__dot" aria-label="Photo ' + (i + 1) + '" aria-current="' + (i === 0) + '" data-ccx-pick-dot="' + i + '"></button>'; }).join('') : '';
      els.pickGal.scrollLeft = 0;
      pick.idx = 0;
    }
    /* 10/10/2026 (demande de Precilia) : meme affichage de prix que sur la fiche produit
       (prix remise, badge -30 % et ancien prix barre). */
    (function () {
      var cents = r.variant ? r.variant.price : p.price_min;
      if (PROMO.on) {
        els.pickPrice.innerHTML = '<span class="ccx-pick__now">' + money2(promoPrice(cents)) + '</span>'
          + '<small class="ccx-pick__pct">-' + PROMO.pct + '\u00a0%</small>'
          + '<s class="ccx-pick__was">' + money2(cents) + '</s>';
      } else {
        els.pickPrice.textContent = money2(cents);
      }
    })();
    var h = '';
    // Couleur : carrés de couleur comme sur la fiche produit
    if (p.colors.length > 1) {
      h += '<div class="ccx-opt ccx-opt--color"><div class="ccx-opt__head"><span class="ccx-opt__name">' + esc(S.color || 'Couleur') + '</span><span class="ccx-opt__val">' + esc(pick.sel.color || '') + '</span></div><div class="ccx-opt__sq" role="radiogroup" aria-label="' + esc(S.color || 'Couleur') + '">';
      p.colors.forEach(function (c) {
        var av = colorAvailable(p, c); var col = (p.swatches || {})[c]; var m = imageFor(p, c);
        h += '<button type="button" class="ccx-sq' + (!av ? ' is-off' : '') + '" role="radio" aria-checked="' + (c === pick.sel.color) + '" aria-label="' + esc(c) + (av ? '' : ' (' + esc(S.sold_out) + ')') + '" data-ccx-pick-color="' + esc(c) + '"><span class="ccx-sq__in"' + (col ? ' style="background:' + esc(col) + '"' : '') + '>' + (col ? '' : '<img src="' + esc(m.thumb || m.src || p.featured) + '" alt="">') + '</span></button>';
      });
      h += '</div></div>';
    }
    // Taille : carte déroulante comme sur la fiche produit
    if (p.size_index >= 0 && p.sizes.length) {
      var sizes = sizesFor(p, pick.sel.color); var cmOf = function (l) { return (p.size_cm || {})[l] || ''; };
      var single = sizes.length === 1; /* 10/10/2026 (demande de Precilia) : tailles toujours affichees a plat, comme sur la fiche produit */ var open = true;
      h += '<div class="ccx-opt ccx-opt--size' + (open ? ' is-open' : '') + '">';
      h += '<button type="button" class="ccx-opt__sizehead" ' + (single ? 'tabindex="-1"' : 'data-ccx-pick-sizetoggle aria-expanded="' + open + '"') + '><span class="ccx-opt__sizetxt"><span class="ccx-opt__name">' + esc(S.size || 'Taille') + '</span><span class="ccx-opt__big">' + esc(pick.sel.size || 'Choisir la taille') + '</span>' + (pick.sel.size && cmOf(pick.sel.size) ? '<span class="ccx-opt__fit">Pour un bébé de <b>' + esc(cmOf(pick.sel.size)) + '</b></span>' : '') + '</span>' + (single ? '' : '<span class="ccx-opt__choose">' + (pick.sel.size ? 'Modifier' : 'Choisir') + '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg></span>') + '</button>';
      if (open) {
        h += '<div class="ccx-opt__list" role="radiogroup" aria-label="' + esc(S.size || 'Taille') + '">';
        sizes.forEach(function (sz) { var on = sz.label === pick.sel.size; h += '<button type="button" class="ccx-opt__row' + (sz.available ? '' : ' is-off') + '" role="radio" aria-checked="' + on + '"' + (sz.available ? '' : ' aria-disabled="true"') + ' data-ccx-pick-size="' + esc(sz.label) + '"><span class="ccx-opt__dot" aria-hidden="true"></span><span class="ccx-opt__rname">' + esc(sz.label) + '</span>' + (sz.available ? '<span class="ccx-opt__cm">' + esc(cmOf(sz.label)) + '</span>' : '<span class="ccx-opt__out">Épuisé</span>') + '</button>'; });
        h += '</div>';
      }
      h += '</div>';
    }
    /* 10/10/2026 (demande de Precilia) : bloc broderie dans la fenetre, comme sur la fiche produit.
       Le prenom et le fil sont ceux du coffret (un seul prenom par coffret) ; la case dit simplement
       si CET article doit etre brode. */
    if (p.embroidery && p.embroidery.eligible) {
      var thr = (p.embroidery.threads || []);
      h += '<div class="ccx-opt ccx-opt--brd' + (pick.emb ? ' is-on' : '') + '">';
      h += '<label class="ccx-brd__head"><input type="checkbox" class="ccx-brd__check" data-ccx-pick-emb' + (pick.emb ? ' checked' : '') + '><span class="ccx-brd__box" aria-hidden="true"></span><span class="ccx-brd__txt">Personnaliser avec son prénom</span></label>';
      if (pick.emb) {
        h += '<div class="ccx-brd__panel">';
        h += '<label class="ccx-brd__lbl" for="ccx-brd-name">Prénom à broder</label>';
        h += '<input id="ccx-brd-name" type="text" class="ccx-brd__name" data-ccx-pick-name maxlength="12" placeholder="Ex. : Louise" value="' + esc(state.name || '') + '">';
        if (thr.length) {
          h += '<span class="ccx-brd__lbl">Couleur du fil' + (state.thread ? ' : <b>' + esc(state.thread) + '</b>' : '') + '</span><div class="ccx-brd__fils">';
          thr.forEach(function (f) {
            h += '<button type="button" class="ccx-brd__fil" role="radio" aria-checked="' + (f.name === state.thread) + '" data-ccx-pick-thread="' + esc(f.name) + '" aria-label="' + esc(f.name) + '"><span style="background:' + esc(f.hex || '#ccc') + '"></span><small>' + esc(f.name) + '</small></button>';
          });
          h += '</div>';
        }
        h += '</div>';
      }
      h += '</div>';
    }
    els.pickBody.innerHTML = h;
    var ok = !!r.variant && r.variant.available;
    els.pickOk.setAttribute('aria-disabled', ok ? 'false' : 'true');
    els.pickOk.textContent = it ? (it.vid === (r.variant && r.variant.id) ? (S.in_box || 'Dans le coffret') : (S.update || 'Mettre à jour')) : (S.add || 'Ajouter au coffret');
    if (els.pickRm) els.pickRm.hidden = !it;
  }
  /* 10/10/2026 : saisie du prenom dans la fenetre article */
  if (els.pick) {
    els.pick.addEventListener('input', function (e) {
      var f = e.target.closest ? e.target.closest('[data-ccx-pick-name]') : null;
      if (!f) return;
      state.name = f.value;
      persist();
    });
  }
  function closePick() {
    if (!els.pick || els.pick.hidden) return;
    els.pick.hidden = true;
    els.pick.classList.remove('is-full');
    if (pick.last && pick.last.focus) try { pick.last.focus({ preventScroll: true }); } catch (e) {}
  }
  function confirmPick() {
    var p = byId[pick.pid]; if (!p) return;
    var r = resolve(p, pick.sel);
    if (!r.variant || !r.variant.available) return;
    var s = selOf(p); s.color = pick.sel.color; s.size = pick.sel.size;
    
    var existing = itemOfProduct(p);
    closePick();
    var wantEmb = !!pick.emb;
    if (existing) { if (existing.vid !== r.variant.id) { swapVariant(existing, r.variant); renderBox(existing.key); } }
    else addItem(p, r.variant);
    /* 10/10/2026 : on applique le choix de broderie fait dans la fenetre */
    if (p.embroidery && p.embroidery.eligible) {
      var itNow = itemOfProduct(p);
      if (itNow) { state.emb[itNow.key] = wantEmb && !!(state.name || '').trim(); persist(); renderBox(itNow.key); }
    }
    renderGrid();
  }

  /* ---------------------------------------------------------------- coffret et paliers */
  function renderProgress(pr) {
    // Jauge en trois tiers : chaque palier au centre de sa colonne (16,7 / 50 / 83,3 %), progression linéaire entre deux paliers
    var v = (pr.net != null ? pr.net : pr.items), pct;
    if (v <= 0) pct = 0;
    else if (v < T.ship) pct = 16.7 * v / T.ship;
    else if (v < T.emb) pct = 16.7 + 33.3 * (v - T.ship) / Math.max(1, T.emb - T.ship);
    else if (v < T.gift) pct = 50 + 33.3 * (v - T.emb) / Math.max(1, T.gift - T.emb);
    else pct = Math.min(100, 83.3 + 16.7 * (v - T.gift) / Math.max(1, T.gift * 0.3));
    $$('[data-ccx-fill]').forEach(function (f) { f.style.width = pct + '%'; });
    ['ship', 'emb', 'gift'].forEach(function (k) {
      var on = pr.flags[k];
      $$('[data-ccx-mile="' + k + '"]').forEach(function (li) { li.classList.toggle('is-on', on); if (on && !prevFlags[k] && started) { li.classList.remove('is-pop'); void li.offsetWidth; li.classList.add('is-pop'); } });
      if (on && !prevFlags[k] && started) toast(tpl(S.toast_unlocked || '{perk}', { perk: (k === 'ship' ? S.ship : k === 'emb' ? S.emb : S.gift).toLowerCase() }), 'ok');
      prevFlags[k] = on;
    });
    var msg;
    if (!pr.flags.ship) msg = tpl(S.to_next_ship, { m: '<b>' + money(T.ship - (pr.net != null ? pr.net : pr.items)) + '</b>' });
    else if (!pr.flags.emb) msg = tpl(S.to_next_emb, { m: '<b>' + money(T.emb - (pr.net != null ? pr.net : pr.items)) + '</b>' });
    else if (!pr.flags.gift && GIFT.variant_id) msg = tpl(S.to_next_gift, { m: '<b>' + money(T.gift - (pr.net != null ? pr.net : pr.items)) + '</b>' });
    else msg = '<span aria-hidden="true">✦</span> ' + esc(S.all_unlocked);
    var done = pr.flags.ship && pr.flags.emb && (pr.flags.gift || !GIFT.variant_id);
    $$('[data-ccx-msg]').forEach(function (m) { m.innerHTML = msg; m.classList.toggle('is-done', done); });
  }
  function renderBox(newKey) {
    var pr = pricing();
    var n = state.items.length;
    els.count.innerHTML = '<b>' + esc(S.box_title || 'Mon coffret') + '</b>' + (n ? ' · ' + esc(n === 1 ? S.count_one : tpl(S.count_many, { n: n })) : '');
    renderProgress(pr);
    if (!n) {
      els.items.innerHTML = '<div class="ccx-items__empty"><p>' + esc(S.empty_title) + '</p><small>' + esc(tpl(S.empty_text, { n: MIN })) + '</small></div>';
    } else {
      els.items.innerHTML = '<p class="ccx-items__lbl">' + esc(S.items_label) + '</p>' + state.items.map(function (it) {
        var p = byId[it.pid]; var v = variantById(p, it.vid); var color = p.color_index >= 0 ? v.options[p.color_index] : ''; var size = p.size_index >= 0 ? v.options[p.size_index] : '';
        var m = imageFor(p, color);
        var meta = [color, size].filter(Boolean).join(' · ');
        var h = '<div class="ccx-item' + (it.key === newKey ? ' is-new' : '') + '" data-ccx-item="' + esc(it.key) + '"><img class="ccx-item__img" src="' + esc(m.thumb || m.src || p.featured) + '" alt="" width="56" height="56"><div class="ccx-item__body"><span class="ccx-item__title">' + esc(shortTitle(p)) + '</span>';
        if (!p.has_only_default_variant) h += '<button type="button" class="ccx-item__meta" data-ccx-item-edit="' + p.id + '">' + (meta ? esc(meta) : esc(S.choose)) + ' <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg></button>';
        if (p.embroidery && p.embroidery.eligible && state.emb[it.key] && state.name.trim()) h += '<span class="ccx-item__emb">' + ICO_EMB + ' « ' + esc(state.name.trim()) + ' »' + (pr.free && pr.free.key === it.key ? ' · <b>' + esc(S.offered) + '</b>' : '') + '</span>';
        h += '</div><div class="ccx-item__end"><b class="ccx-item__price">' + money2(PROMO.on ? promoPrice(v.price) : v.price) + '</b>' + (PROMO.on ? '<s class="ccx-item__was">' + money2(v.price) + '</s>' : '') + '<button type="button" class="ccx-item__rm" data-ccx-rm aria-label="' + esc(S.remove) + ' ' + esc(p.title) + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div></div>';
        return h;
      }).join('');
    }
    renderEmbCta(pr);
    renderSum(pr, els.sum);
    var ok = n >= MIN;
    els.add.setAttribute('aria-disabled', ok ? 'false' : 'true');
    els.add.classList.remove('is-loading');
    if (els.addPrice) els.addPrice.innerHTML = money2(pr.total) + (pr.disc ? ' <s>' + money2(pr.before) + '</s>' : '');
    els.hint.textContent = ok ? '' : tpl(S.cta_min, { n: MIN - n, s: MIN - n > 1 ? 's' : '' });
    els.hint.hidden = ok;
    if (ok && els.err && !els.err.hidden) { els.err.hidden = true; els.err.textContent = ''; }
    els.bar.hidden = false;
    els.barTotal.textContent = money2(pr.total);
    els.barCount.textContent = n === 0 ? (S.empty_title || '') : (n === 1 ? S.count_one : tpl(S.count_many, { n: n }));
    els.bar.classList.toggle('is-bump', !!newKey);
    root.classList.toggle('ccx--has-items', n > 0);
    persist();
  }
  function renderEmbCta(pr) {
    var elig = eligibleItems();
    if (!els.embcta) return;
    els.embcta.hidden = !elig.length;
    if (!elig.length) return;
    var embs = embItems(); var name = state.name.trim();
    if (embs.length && name) {
      els.embcta.innerHTML = '<button type="button" class="ccx-embcta__btn is-set" data-ccx-emb-open><span class="ccx-embcta__ico">' + ICO_EMB + '</span><span class="ccx-embcta__txt"><b>« ' + esc(name) + ' » brodé sur ' + embs.length + ' article' + (embs.length > 1 ? 's' : '') + '</b><small>' + (state.thread ? 'Fil ' + esc(state.thread) + ' · ' : '') + (pr.free ? esc(S.sum_emb_free) : '+ ' + money2(pr.embPaid)) + (pr.free && pr.embPaid ? ' · + ' + money2(pr.embPaid) : '') + '</small></span><span class="ccx-embcta__edit">' + esc(S.edit || 'Modifier') + '</span></button>';
    } else {
      els.embcta.innerHTML = '<button type="button" class="ccx-embcta__btn" data-ccx-emb-open><span class="ccx-embcta__ico">' + ICO_EMB + '</span><span class="ccx-embcta__txt"><b>' + esc(S.emb_cta || 'Broder 1 ou plusieurs articles') + '</b><small>' + (pr.flags.emb && FEE.free_id ? esc(S.sum_emb_free) + ' · ' : '') + tpl(S.emb_fee, { m: money2(FEE.price) }) + '</small></span><span class="ccx-embcta__edit">+</span></button>';
    }
  }

  var embLast = null;
  function openEmb(errMsg) {
    if (!els.embsheet) return;
    embLast = document.activeElement;
    renderEmb();
    if (els.embErr) { els.embErr.textContent = errMsg || ''; els.embErr.hidden = !errMsg; }
    els.embsheet.hidden = false;
    setTimeout(function () { try { if (!state.name) els.name.focus({ preventScroll: true }); } catch (e) {} }, 80);
  }
  function closeEmb() {
    if (!els.embsheet || els.embsheet.hidden) return;
    els.embsheet.hidden = true;
    renderBox();
    if (embLast && embLast.focus) try { embLast.focus({ preventScroll: true }); } catch (e) {}
  }
  function renderEmb() {
    var pr = pricing();
    var elig = eligibleItems();
    if (els.name.value !== state.name) els.name.value = state.name;
    var threads = threadsFor();
    if (threads.length && !threads.some(function (t) { return t.name === state.thread; })) state.thread = '';
    els.threads.innerHTML = threads.length ? '<span class="ccx-threads__lbl">' + esc(S.thread_label) + (state.thread ? ' · <b>' + esc(state.thread) + '</b>' : '') + '</span><div class="ccx-threads__list" role="radiogroup">' + threads.map(function (t) { return '<button type="button" class="ccx-thread" role="radio" aria-checked="' + (t.name === state.thread) + '" aria-label="' + esc(t.name) + '" title="' + esc(t.name) + '" data-ccx-thread="' + esc(t.name) + '" style="--c:' + esc(t.hex || '#999') + '"></button>'; }).join('') + '</div>' : '';
    if (!elig.length) { els.embitems.innerHTML = '<p class="ccx-embitems__none">' + esc(S.emb_none) + '</p>'; els.embfree.hidden = true; els.embfee.textContent = ''; return; }
    els.embitems.innerHTML = elig.map(function (it) {
      var p = byId[it.pid]; var on = !!state.emb[it.key]; var isFree = pr.free && pr.free.key === it.key; var v = variantById(p, it.vid); var m = imageFor(p, p.color_index >= 0 ? v.options[p.color_index] : '');
      return '<label class="ccx-embitem' + (on ? ' is-on' : '') + '"><input type="checkbox" data-ccx-emb="' + esc(it.key) + '"' + (on ? ' checked' : '') + '><span class="ccx-embitem__box" aria-hidden="true">' + ICO_CHECK + '</span><img class="ccx-embitem__img" src="' + esc(m.thumb || m.src || p.featured) + '" alt="" width="40" height="40"><span class="ccx-embitem__txt">' + esc(shortTitle(p)) + '</span><span class="ccx-embitem__fee' + (isFree ? ' is-free' : '') + '">' + (isFree ? esc(S.offered) : (on ? '+ ' + money2(FEE.price) : '')) + '</span></label>';
    }).join('');
    var embs = embItems();
    els.embfree.hidden = true;
    els.embfee.innerHTML = tpl(S.emb_fee, { m: money2(FEE.price) }) + (pr.flags.emb && FEE.free_id ? ' · <b class="ccx-ok">' + esc(S.sum_emb_free) + '</b>' : ' · <span>' + esc(tpl(S.from, { m: money(T.emb) })) + ', ' + esc((S.emb || '').toLowerCase()) + '</span>');
  }
  function validateEmb() {
    var embs = embItems();
    if (!embs.length) return true;
    if (!state.name.trim()) { if (els.embErr) { els.embErr.textContent = S.err_name_short || 'Indiquez le prénom à broder.'; els.embErr.hidden = false; } els.name.focus(); return false; }
    if (threadsFor().length && !state.thread) { if (els.embErr) { els.embErr.textContent = S.err_thread; els.embErr.hidden = false; } return false; }
    return true;
  }
  function renderSum(pr, dl) {
    var rows = [];
    if (pr.embN) rows.push('<div' + (pr.free ? ' class="ccx-sum__free"' : '') + '><dt>' + esc(tpl(S.sum_emb, { n: pr.embN })) + '</dt><dd>' + (pr.embPaid ? money2(pr.embPaid) : '<b class="ccx-ok">' + esc(S.offered) + '</b>') + (pr.free ? ' <s>' + money2(FEE.price * pr.embN) + '</s>' : '') + '</dd></div>');
    if (pr.gift) rows.push('<div class="ccx-sum__free"><dt>' + esc(S.sum_gift) + (state.name.trim() ? ' « ' + esc(state.name.trim()) + ' »' : '') + '</dt><dd><b class="ccx-ok">' + esc(S.offered) + '</b></dd></div>');
    if (pr.ship) rows.push('<div class="ccx-sum__free"><dt>' + esc(S.sum_ship) + '</dt><dd><b class="ccx-ok">' + esc(S.offered) + '</b>' + (DATA.ship_price ? ' <s>' + money2(DATA.ship_price) + '</s>' : '') + '</dd></div>');
    if (pr.disc) rows.push('<div class="ccx-sum__free ccx-sum__promo"><dt>Remise exceptionnelle (-' + PROMO.pct + ' %)</dt><dd>-' + money2(pr.disc) + '</dd></div>');
    rows.push('<div class="ccx-sum__total"><dt>' + esc(S.sum_total) + '</dt><dd>' + money2(pr.total) + '</dd></div>');
    dl.innerHTML = rows.join('');
  }

  /* ---------------------------------------------------------------- actions */
  function addItem(p, variant) {
    if (!variant || !variant.available) return false;
    if (itemFor(variant.id)) return false;
    started = true;
    var it = { key: String(variant.id), pid: p.id, vid: variant.id };
    state.items.push(it);
    if (p.embroidery && p.embroidery.eligible && state.emb[it.key] == null) state.emb[it.key] = false;
    renderBox(it.key);
    refreshCard(p.id);
    track('compose_add_item', { product_id: p.id, variant_id: variant.id, value: variant.price / 100 });
    return true;
  }
  function removeItem(key) {
    var it = itemFor(parseInt(key, 10)); if (!it) return;
    var p = byId[it.pid];
    state.items = state.items.filter(function (x) { return x.key !== it.key; });
    delete state.emb[it.key];
    if (state.freeKey === it.key) state.freeKey = '';
    renderBox();
    refreshCard(p.id);
  }
  function swapVariant(it, newVariant) {
    if (!newVariant || !newVariant.available || newVariant.id === it.vid || itemFor(newVariant.id)) return;
    var wasEmb = state.emb[it.key]; var wasFree = state.freeKey === it.key;
    delete state.emb[it.key];
    it.key = String(newVariant.id); it.vid = newVariant.id;
    if (wasEmb != null) state.emb[it.key] = wasEmb;
    if (wasFree) state.freeKey = it.key;
  }
  var toastTimer;
  function toast(msg, kind) {
    if (!msg) return;
    els.toast.textContent = msg;
    els.toast.className = 'ccx-toast is-' + (kind || 'info') + ' is-show';
    els.toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { els.toast.classList.remove('is-show'); setTimeout(function () { els.toast.hidden = true; }, 300); }, 2200);
  }
  function openSide() { els.side.classList.add('is-open'); els.overlay.hidden = false; document.documentElement.classList.add('ccx-lock'); els.bar.classList.add('is-hidden'); }
  function closeSide() { els.side.classList.remove('is-open'); els.overlay.hidden = true; document.documentElement.classList.remove('ccx-lock'); els.bar.classList.remove('is-hidden'); }
  function showErr(msg, html) { if (html) els.err.innerHTML = msg; else els.err.textContent = msg; els.err.hidden = !msg; if (msg) { els.err.scrollIntoView({ block: 'nearest', behavior: REDUCED ? 'auto' : 'smooth' }); } }
  function track(name, params) {
    var payload = Object.assign({ currency: 'EUR', bundle_id: 'compose', universe: state.universe }, params || {});
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, payload)); } catch (e) {}
    try { if (window.gtag) window.gtag('event', name, payload); } catch (e) {}
    try { if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish(name, payload); } catch (e) {}
  }

  /* ---------------------------------------------------------------- ajout au panier */
  var adding = false;
  function validate() {
    showErr('');
    if (state.items.length < MIN) { showErr(tpl(S.cta_min, { n: MIN - state.items.length, s: MIN - state.items.length > 1 ? 's' : '' })); return false; }
    var pr = pricing();
    var name = state.name.trim();
    if (pr.embN && !name) { openEmb(S.err_name_short || 'Indiquez le prénom à broder.'); return false; }
    if (pr.embN && threadsFor().length > 0 && !state.thread) { openEmb(S.err_thread); return false; }
    if (pr.giftPossible && !name) { openEmb(S.gift_need_name_long || 'Indiquez le prénom pour l’attache tétine offerte (ou choisissez « Sans broderie » pour continuer sans).'); return false; }
    return true;
  }
  function buildItems(inst) {
    var pr = pricing();
    var name = state.name.trim();
    var thread = state.thread || '';
    var u = uniOf(state.universe);
    var bundleName = (name ? 'Coffret cadeau de ' + name : 'Coffret cadeau composé') + (u ? ' · ' + u.label : '');
    var base = { 'Coffret': 'Coffret composé', '_bundle_id': 'compose', '_bundle_name': bundleName, '_bundle_instance': inst };
    var embs = embItems();
    var summary = embs.length ? ('Prénom ' + name + (thread ? ' · Fil ' + thread : '') + ' · Articles à broder : ' + embs.map(function (it) { return byId[it.pid].title; }).join(', ')) : 'Sans broderie';
    var items = [];
    state.items.forEach(function (it, idx) {
      var p = byId[it.pid];
      var props = Object.assign({}, base);
      if (idx === 0) props['Broderie du coffret'] = summary;
      var e = !!state.emb[it.key] && p.embroidery && p.embroidery.eligible && name;
      var feeId = (pr.free && pr.free.key === it.key && FEE.free_id) ? FEE.free_id : FEE.paid_id;
      if (e) { props['Broderie'] = 'Prénom « ' + name + ' »' + (thread ? ' · Fil ' + thread : ''); props['_broderie'] = 'oui'; props['_brd_fee'] = String(feeId); }
      items.push({ id: it.vid, quantity: 1, properties: props });
      if (e && feeId) {
        var fee = { 'Article': p.title, 'Prénom': name };
        if (thread) fee['Couleur du fil'] = thread;
        fee['_cc_for'] = it.vid + '|' + name + '|' + thread + '|' + inst;
        fee['Coffret'] = base['Coffret']; fee['_bundle_id'] = 'compose'; fee['_bundle_instance'] = inst;
        items.push({ id: feeId, quantity: 1, properties: fee });
      }
    });
    if (pr.gift && GIFT.variant_id) {
      var g = Object.assign({}, base, { 'Cadeau': 'Offerte dès ' + money(T.gift), 'Prénom': name });
      if (thread) g['Couleur du fil'] = thread;
      items.push({ id: GIFT.variant_id, quantity: 1, properties: g });
    }
    return items;
  }
  function refreshAvailability(done) {
    var pids = {}; state.items.forEach(function (it) { pids[it.pid] = true; });
    var list = Object.keys(pids); var pending = list.length;
    if (!pending) { done(); return; }
    list.forEach(function (pid) {
      var p = byId[pid];
      fetch(DATA.root + 'products/' + p.handle + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (pj) {
        if (pj && pj.variants) { p.available = !!pj.available; p.variants.forEach(function (v) { pj.variants.forEach(function (fv) { if (fv.id === v.id) { v.available = !!fv.available; v.price = fv.price; } }); }); }
      }).catch(function () {}).then(function () { if (--pending === 0) done(); });
    });
  }
  function addToCart() {
    if (adding) return;
    if (!validate()) return;
    adding = true;
    var pr = pricing();
    els.add.setAttribute('aria-disabled', 'true'); els.add.classList.add('is-loading');
    var inst = 'cx' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    fetch(DATA.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' }, body: JSON.stringify({ items: buildItems(inst), sections: 'cart-icon-bubble', sections_url: location.pathname }) })
      .then(function (r) { return r.json().then(function (j) { return { status: r.status, body: j }; }); })
      .then(function (res) {
        if (res.status >= 400 || (res.body && res.body.status >= 400)) { var err = new Error('add'); err.stock = res.status === 422 || (res.body && res.body.status === 422); throw err; }
        try { var sec = res.body.sections && res.body.sections['cart-icon-bubble']; var bubble = document.getElementById('cart-icon-bubble'); if (sec && bubble) { var dom = new DOMParser().parseFromString(sec, 'text/html'); var fresh = dom.getElementById('cart-icon-bubble') || dom.body.firstElementChild; if (fresh) bubble.innerHTML = fresh.innerHTML; } } catch (e) {}
        return fetch(DATA.root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        track('compose_add_to_cart', { bundle_instance: inst, value: pr.total / 100, product_count: state.items.length, embroidery_count: pr.embN, gift: pr.gift, personalized: pr.embN > 0 });
        try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cc-composer', cartData: cart }); } catch (e) {}
        try { if (typeof window.ccShipRefresh === 'function') window.ccShipRefresh(); } catch (e) {}
        // 10/10/2026 (demande de Precilia) : le coffret est parti ; on repart d'un coffret vide et on
        // ouvre le tiroir panier lateral, comme sur les fiches produit, au lieu d'aller au paiement.
        state.items = []; state.emb = {}; state.freeKey = ''; state.noGift = false;
        persist();
        (function () {
          var drawer = document.querySelector('cart-drawer');
          if (!drawer || typeof drawer.renderContents !== 'function') {
            window.location.href = (DATA.root || '/').replace(/\/$/, '') + '/cart';
            return;
          }
          var ids = (typeof drawer.getSectionsToRender === 'function' ? drawer.getSectionsToRender() : []).map(function (s) { return s.id; });
          if (ids.indexOf('cart-drawer') < 0) ids.push('cart-drawer');
          if (ids.indexOf('cart-icon-bubble') < 0) ids.push('cart-icon-bubble');
          fetch((DATA.root || '/') + '?sections=' + ids.join(','))
            .then(function (r) { return r.json(); })
            .then(function (sections) {
              drawer.classList.remove('is-empty');
              (typeof drawer.getSectionsToRender === 'function' ? drawer.getSectionsToRender() : []).forEach(function (s) {
                var target = (s.selector && document.querySelector(s.selector)) || document.getElementById(s.id);
                if (!sections[s.id] || !target) return;
                var dom = new DOMParser().parseFromString(sections[s.id], 'text/html');
                var fresh = (s.selector && dom.querySelector(s.selector)) || dom.getElementById(s.id);
                if (fresh) target.innerHTML = fresh.innerHTML;
              });
              if (typeof drawer.open === 'function') drawer.open();
            })
            .catch(function () { window.location.href = (DATA.root || '/').replace(/\/$/, '') + '/cart'; });
        })();
      })
      .catch(function (err) {
        if (err && err.stock) refreshAvailability(function () { state.items = state.items.filter(function (it) { var v = variantById(byId[it.pid], it.vid); return v && v.available; }); renderBox(); renderGrid(); showErr(S.err_stock); }); else showErr(S.err_add);
      })
      .then(function () {
        adding = false;
        if (state.items.length) renderBox();
      });
  }

  /* ---------------------------------------------------------------- événements */
  function onToggle(card) {
    var p = byId[card.getAttribute('data-ccx-card')]; if (!p) return;
    var existing = itemOfProduct(p);
    if (existing) { removeItem(existing.vid); return; }
    if (needsChoice(p)) { openPick(p.id); return; }
    var r = resolve(p);
    if (!r.variant || !r.variant.available) { openPick(p.id); return; }
    addItem(p, r.variant);
  }
  root.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var b;
    if ((b = t.closest('[data-ccx-universe]'))) {
      var nu = b.getAttribute('data-ccx-universe') || '';
      if (nu === state.universe) return;
      if (state.items.length && !window.confirm(S.uni_switch || 'Changer d’univers videra votre coffret. Continuer ?')) return;
      state.universe = nu; state.items = []; state.emb = {}; state.freeKey = ''; state.noGift = false;
      renderUnis(); renderGrid(); renderBox(); persist(); track('compose_universe', {});
      var st2 = $('.ccx-lbl--2'); if (st2) setTimeout(function () { st2.scrollIntoView({ block: 'start', behavior: REDUCED ? 'auto' : 'smooth' }); }, 80);
      return;
    }
    /* 10/10/2026 (demande de Precilia) : la pastille verte de validation retire l'article du coffret */
    if (t.closest('.ccx-card__check')) {
      var ccEl = t.closest('[data-ccx-card]');
      var ccP = ccEl && byId[ccEl.getAttribute('data-ccx-card')];
      var ccIt = ccP && itemOfProduct(ccP);
      if (ccIt) { removeItem(ccIt.key); renderGrid(); }
      return;
    }
    if ((b = t.closest('[data-ccx-media]'))) { openPick(b.closest('[data-ccx-card]').getAttribute('data-ccx-card')); return; }
    /* 10/10/2026 (demande de Precilia) : un clic sur la carte ouvre la fenetre de l'article,
       il n'y a plus d'ajout automatique au coffret depuis la grille. */
    if ((b = t.closest('[data-ccx-toggle]'))) { openPick(b.closest('[data-ccx-card]').getAttribute('data-ccx-card')); return; }
    if ((b = t.closest('[data-ccx-pick-color]'))) { pick.sel.color = b.getAttribute('data-ccx-pick-color'); var p0 = byId[pick.pid]; if (p0 && pick.sel.size && !sizesFor(p0, pick.sel.color).some(function (x) { return x.label === pick.sel.size && x.available; })) pick.sel.size = ''; renderPick(true); return; }
    /* 10/10/2026 (demande de Precilia) : broderie choisie dans la fenetre article */
    if ((b = t.closest('[data-ccx-pick-emb]'))) { pick.emb = !pick.emb; renderPick(false); return; }
    if ((b = t.closest('[data-ccx-pick-thread]'))) { state.thread = b.getAttribute('data-ccx-pick-thread'); persist(); renderPick(false); return; }
    if ((b = t.closest('[data-ccx-pick-sizetoggle]'))) { pick.sizeOpen = !pick.sizeOpen; renderPick(false); return; }
    if ((b = t.closest('[data-ccx-pick-size]'))) { if (b.getAttribute('aria-disabled') === 'true') return; pick.sel.size = b.getAttribute('data-ccx-pick-size'); pick.sizeOpen = false; renderPick(false); return; }
    if ((b = t.closest('[data-ccx-pick-arw]'))) {
      var dir = parseInt(b.getAttribute('data-ccx-pick-arw'), 10) || 1;
      var n = els.pickGal.children.length;
      var ni = Math.max(0, Math.min(n - 1, (pick.idx || 0) + dir));
      var sl2 = els.pickGal.children[ni];
      if (sl2) els.pickGal.scrollTo({ left: sl2.offsetLeft, behavior: REDUCED ? 'auto' : 'smooth' });
      return;
    }
    if ((b = t.closest('[data-ccx-pick-dot]'))) { var i = parseInt(b.getAttribute('data-ccx-pick-dot'), 10); var sl = els.pickGal.children[i]; if (sl) els.pickGal.scrollTo({ left: sl.offsetLeft, behavior: REDUCED ? 'auto' : 'smooth' }); return; }
    if ((b = t.closest('[data-ccx-pick-ok]'))) { if (b.getAttribute('aria-disabled') === 'true') return; confirmPick(); return; }
    if ((b = t.closest('[data-ccx-pick-rm]'))) { var pe = byId[pick.pid]; var ex = pe && itemOfProduct(pe); closePick(); if (ex) removeItem(ex.vid); return; }
    if ((b = t.closest('[data-ccx-pick-close]'))) { closePick(); return; }
    if (t === els.pick) { closePick(); return; }
    if ((b = t.closest('[data-ccx-item-edit]'))) { openPick(b.getAttribute('data-ccx-item-edit')); return; }
    if ((b = t.closest('[data-ccx-rm]'))) { var row = b.closest('[data-ccx-item]'); removeItem(row.getAttribute('data-ccx-item')); return; }
    if ((b = t.closest('[data-ccx-thread]'))) { state.thread = b.getAttribute('data-ccx-thread'); renderEmb(); persist(); return; }
    if ((b = t.closest('[data-ccx-open]'))) { openSide(); return; }
    if ((b = t.closest('[data-ccx-close]'))) { closeSide(); return; }
    if ((b = t.closest('[data-ccx-add]'))) { addToCart(); return; }
    if ((b = t.closest('[data-ccx-emb-open]'))) { openEmb(); return; }
    if ((b = t.closest('[data-ccx-emb-ok]'))) { if (validateEmb()) closeEmb(); return; }
    if ((b = t.closest('[data-ccx-emb-none]'))) { Object.keys(state.emb).forEach(function (k) { state.emb[k] = false; }); state.noGift = !state.name.trim(); if (els.embErr) els.embErr.hidden = true; closeEmb(); return; }
    if ((b = t.closest('[data-ccx-emb-close]'))) { closeEmb(); return; }
    if (t === els.embsheet) { closeEmb(); return; }
    if (t === els.overlay) { closeSide(); return; }
  });
  /* fiche article : la photo suit le doigt — vers le haut = photo entière en grand, vers le bas = réduire puis fermer */
  (function () {
    if (!els.pick || !els.pickGal) return;
    var card = els.pick.querySelector('.ccx-pick__card'), gal = els.pickGal; if (!card) return;
    var y0 = 0, x0 = 0, dy = 0, drag = false, decided = false, onGal = false, h0 = 0, full = false;
    function vh() { return window.innerHeight || document.documentElement.clientHeight; }
    function setFull(on) {
      els.pick.classList.toggle('is-full', on); gal.style.height = ''; gal.style.maxHeight = ''; card.style.transform = '';
      if (on) card.scrollTop = 0;
      var i = pick.idx || 0; requestAnimationFrame(function () { var sl = gal.children[i]; if (sl) gal.scrollLeft = sl.offsetLeft; });
    }
    window.__ccxSetFull = setFull;
    card.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      onGal = !!e.target.closest('.ccx-pick__galwrap');
      if (!onGal && card.scrollTop > 0) { drag = false; return; }
      y0 = e.touches[0].clientY; x0 = e.touches[0].clientX; dy = 0; drag = true; decided = false;
      full = els.pick.classList.contains('is-full'); h0 = gal.offsetHeight;
    }, { passive: true });
    card.addEventListener('touchmove', function (e) {
      if (!drag) return;
      var ny = e.touches[0].clientY - y0, nx = e.touches[0].clientX - x0;
      if (!decided) {
        if (Math.abs(ny) < 6 && Math.abs(nx) < 6) return;
        decided = true;
        if (Math.abs(nx) > Math.abs(ny)) { drag = false; return; }
        if (!onGal && ny < 0) { drag = false; return; }
        card.style.transition = 'none'; gal.style.transition = 'none';
      }
      dy = ny; if (e.cancelable) e.preventDefault();
      var maxH = Math.round(vh() * .74), minH = Math.round(vh() * .34);
      if (dy < 0) { gal.style.maxHeight = 'none'; gal.style.height = Math.min(maxH, h0 - dy) + 'px'; card.style.transform = ''; }
      else if (full && onGal) { var nh = h0 - dy; if (nh > minH) { gal.style.maxHeight = 'none'; gal.style.height = nh + 'px'; card.style.transform = ''; } else { gal.style.maxHeight = 'none'; gal.style.height = minH + 'px'; card.style.transform = 'translateY(' + Math.round((minH - nh) * .7) + 'px)'; } }
      else card.style.transform = 'translateY(' + Math.round(dy * .85) + 'px)';
    }, { passive: false });
    card.addEventListener('touchend', function () {
      if (!drag) return; drag = false;
      card.style.transition = ''; gal.style.transition = '';
      if (!decided) return;
      if (dy < -40) setFull(true);
      else if (dy > 80) {
        if (full && onGal && dy < vh() * .5) setFull(false);
        else { setFull(false); closePick(); }
      } else setFull(full);
    });
    gal.addEventListener('click', function (e) { if (e.target.tagName === 'IMG') setFull(!els.pick.classList.contains('is-full')); });
    var grab = document.createElement('button'); grab.type = 'button'; grab.className = 'ccx-pick__grab'; grab.setAttribute('aria-label', 'Agrandir ou réduire la photo');
    grab.addEventListener('click', function () { setFull(!els.pick.classList.contains('is-full')); });
    var gw = card.querySelector('.ccx-pick__galwrap'); if (gw) gw.appendChild(grab);
  })();

  /* fiche article : détails du produit (description, fabrication, matière) chargés à l'ouverture */
  var DESC = {};
  function loadDesc(pid) {
    var p = byId[pid]; if (!p || !els.pick) return;
    var card = els.pick.querySelector('.ccx-pick__card');
    var box = card.querySelector('[data-ccx-pick-desc]');
    if (!box) { box = document.createElement('div'); box.className = 'ccx-pick__desc'; box.setAttribute('data-ccx-pick-desc', ''); card.appendChild(box); }
    var url = (DATA.root || '/').replace(/\/$/, '') + '/products/' + p.handle;
    function paint(html) {
      box.innerHTML = '<p class="ccx-pick__desc-t">Détails de l’article</p>'
        + '<ul class="ccx-pick__facts"><li>' + '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-6.5-5.6-6.5-11a6.5 6.5 0 0 1 13 0c0 5.4-6.5 11-6.5 11z"/><circle cx="12" cy="10" r="2.4"/></svg>Confectionné au Portugal</li>'
        + (p.embroidery && p.embroidery.eligible ? '<li><svg viewBox="0 0 24 24" aria-hidden="true"><rect x="6" y="4" width="12" height="16" rx="2.5"/><path d="M6 8.5h12M6 12h12M6 15.5h12"/></svg>Prénom brodé dans notre atelier à Paris</li>' : '')
        + '<li><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>Expédié sous 72h</li></ul>'
        + (html ? '<div class="ccx-pick__rte">' + html + '</div>' : '')
        + '<a class="ccx-link ccx-link--sm" href="' + esc(url) + '" target="_blank" rel="noopener">Voir la fiche complète</a>';
    }
    if (DESC[pid] != null) { paint(DESC[pid]); return; }
    paint('');
    fetch(url + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (d) {
      var tmp = document.createElement('div'); tmp.innerHTML = d.description || '';
      tmp.querySelectorAll('script,style,iframe,img,video,form').forEach(function (n) { n.remove(); });
      DESC[pid] = tmp.innerHTML; if (pick.pid === pid || !pick.pid) paint(DESC[pid]);
    }).catch(function () { DESC[pid] = ''; });
  }
  var _openPick = openPick;
  openPick = function (pid) { pick.sizeOpen = false; var p0 = byId[pid]; if (p0 && p0.size_index >= 0 && !(selOf(p0).size)) pick.sizeOpen = true; _openPick(pid); loadDesc(pid); };

  /* sélecteur de catégorie : clic ou glissé gauche / droite */
  (function () {
    var seg = $('[data-ccx-seg]'); if (!seg) return;
    var cats = Array.prototype.map.call(seg.querySelectorAll('[data-ccx-cat]'), function (b) { return b.getAttribute('data-ccx-cat'); });
    seg.addEventListener('click', function (e) { var b = e.target.closest('[data-ccx-cat]'); if (b) { setCat(b.getAttribute('data-ccx-cat')); track('compose_category', {}); } });
    var x0 = null;
    seg.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    seg.addEventListener('touchend', function (e) { if (x0 == null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) < 30) return; var i = cats.indexOf(CAT); i = Math.max(0, Math.min(cats.length - 1, i + (dx < 0 ? 1 : -1))); setCat(cats[i]); });
    seg.addEventListener('keydown', function (e) { if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return; var i = cats.indexOf(CAT); i = Math.max(0, Math.min(cats.length - 1, i + (e.key === 'ArrowRight' ? 1 : -1))); setCat(cats[i]); var b = seg.querySelectorAll('[data-ccx-cat]')[i]; if (b) b.focus(); });
  })();

  /* code promo : un toucher l'applique (appliqué automatiquement au paiement) */
  (function () {
    var b = $('[data-ccx-promo]'); if (!b || b.tagName !== 'BUTTON') return;
    var code = b.getAttribute('data-ccx-promo');
    var KEY = 'ccx:promo';
    function show(on) {
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var sub = b.querySelector('[data-ccx-promo-sub]'), st = b.querySelector('[data-ccx-promo-state]');
      if (on) { sub.textContent = 'Réduction déduite au paiement'; st.innerHTML = ICO_CHECK; }
    }
    try { if (localStorage.getItem(KEY) === code) show(true); } catch (e) {}
    b.addEventListener('click', function () {
      if (b.classList.contains('is-on')) return;
      show(true); PROMO.on = true; renderBox();
      try { localStorage.setItem(KEY, code); } catch (e) {}
      var base = (DATA.root || '/').replace(/\/$/, '');
      fetch(base + '/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
      fetch(base + '/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: code }) }).catch(function () {});
      track('compose_promo', { code: code });
    });
  })();

  if (els.pickGal) {
    var galTimer;
    els.pickGal.addEventListener('scroll', function () {
      clearTimeout(galTimer);
      galTimer = setTimeout(function () { var w = els.pickGal.clientWidth || 1; var i = Math.round(els.pickGal.scrollLeft / w); if (i !== pick.idx) { pick.idx = i; $$('[data-ccx-pick-dot]').forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); }); } }, 60);
    }, { passive: true });
  }
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-ccx-emb]')) { state.emb[t.getAttribute('data-ccx-emb')] = t.checked; started = true; if (t.checked) state.noGift = false; renderEmb(); persist(); return; }
    if (t.matches('[data-ccx-free]')) { state.freeKey = t.value; renderEmb(); persist(); return; }
  });
  els.name.addEventListener('input', function () {
    var v = els.name.value.replace(/[^\p{L}\p{M}' \-]/gu, '').slice(0, FEE.max || 12);
    if (v !== els.name.value) els.name.value = v;
    state.name = v; started = true;
    if (v.trim()) state.noGift = false;
    if (els.embErr) els.embErr.hidden = true;
    persist();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (els.pick && !els.pick.hidden) { closePick(); return; }
    if (els.embsheet && !els.embsheet.hidden) { closeEmb(); return; }
    if (els.side.classList.contains('is-open')) closeSide();
  });

  /* ---------------------------------------------------------------- lien depuis une fiche produit */
  function handleDeepLink() {
    var q = new URLSearchParams(location.search);
    var handle = q.get('add'); if (!handle) return;
    var vid = parseInt(q.get('variant'), 10);
    var p = P.filter(function (x) { return x.handle === handle; })[0];
    if (!p) return;
    var inUni = UNIS.filter(function (u) { return p.collections.indexOf(u.handle) > -1; })[0];
    if (inUni) state.universe = inUni.handle;
    var v = vid ? variantById(p, vid) : null;
    if (v) { var s = selOf(p); if (p.color_index >= 0) s.color = v.options[p.color_index]; if (p.size_index >= 0) s.size = v.options[p.size_index]; }
    if (v && v.available) addItem(p, v);
    else { var r = resolve(p); if (r.variant && r.variant.available && !needsChoice(p)) addItem(p, r.variant); else openPick(p.id); }
    try { history.replaceState(null, '', location.pathname); } catch (e) {}
    renderUnis(); renderGrid();
    setTimeout(function () { var card = $('[data-ccx-card="' + p.id + '"]'); if (card) { card.classList.add('is-hl'); card.scrollIntoView({ block: 'center', behavior: REDUCED ? 'auto' : 'smooth' }); } }, 120);
  }

  (function () {
    var heroProg = $('.ccx-progress--hero');
    if (!heroProg || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      els.bar.classList.toggle('is-prog', !e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 });
    io.observe(heroProg);
  })();

  /* ---------------------------------------------------------------- init */
  renderUnis(); renderGrid(); renderBox();
  handleDeepLink();
  try { if (new URLSearchParams(location.search).get('univers')) history.replaceState(null, '', location.pathname); } catch (e) {}
  started = true;
  track('compose_view', { product_count: state.items.length });
  window.ccComposer = { state: state, pricing: pricing, data: DATA };
})();
